import { useMap } from '@vis.gl/react-google-maps'
import { useTranslation } from 'react-i18next'
import { useSearchParams } from 'react-router'

import { Icon } from '@/components/icon'
import SelectPopover from '@/components/select-popover'
import { Button } from '@/components/ui'
import type { Coordinate, TGetBlocosResponse } from '@/types/blocos'
import { StringUtils } from '@/utils'

interface IMenuNavegacaoQuadraProps {
  quadras: TGetBlocosResponse['blocos']
  initialRegion: Coordinate
}

type TQuadraMenu = Array<
  Pick<TGetBlocosResponse['blocos'][0], 'idExterno' | 'nome' | 'coordenada' | 'quantidadeLotesDisponiveis'>
>

export const MenuNavegacaoQuadra = ({ quadras, initialRegion }: IMenuNavegacaoQuadraProps) => {
  const map = useMap()
  const [searchParams, setSearchParams] = useSearchParams()
  const { t } = useTranslation(['espelho-de-vendas'])

  const quadrasComVisaoGeral: TQuadraMenu = [
    {
      idExterno: 0,
      nome: t('navegacao_quadras.visao_geral'),
      coordenada: initialRegion,
      quantidadeLotesDisponiveis: quadras.reduce((acc, quadra) => acc + quadra.quantidadeLotesDisponiveis, 0),
    },
    ...quadras,
  ]
  const quadraSelecionada = searchParams.get('quadra')
    ? quadras.find((q) => q.idExterno.toString() === searchParams.get('quadra'))?.nome
    : null

  const onSelectQuadra = (quadraId: string) => {
    const quadra = quadrasComVisaoGeral.find((q) => q.idExterno.toString() === quadraId)
    if (quadra) {
      map?.setCenter({ lat: quadra.coordenada.latitude, lng: quadra.coordenada.longitude })
      setSearchParams((state) => {
        if (quadra.nome.includes('geral')) {
          state.delete('quadra')
          return state
        }
        state.set('quadra', quadra.idExterno.toString())
        return state
      })
    }
  }

  const selectOptions = quadrasComVisaoGeral.map((quadra) => ({
    id: quadra.idExterno.toString(),
    label: `${quadra.nome} - ${quadra.quantidadeLotesDisponiveis} ${StringUtils.singularPlural(quadra.quantidadeLotesDisponiveis, 'disponível', 'disponíveis')}`,
  }))

  return (
    <SelectPopover
      title={t('navegacao_quadras.quadras')}
      options={selectOptions}
      onSelect={onSelectQuadra}
      triggerButton={
        <Button className="mb-4 w-fit">
          <Icon name="land-plot" />
          {quadraSelecionada ?? t('navegacao_quadras.navegue')}
        </Button>
      }
      className="font-poppins max-h-[300px] overflow-auto px-3 pt-2 pb-3"
    />
  )
}
